<template>
  <div class="c-new-summary-dialog">
    <v-dialog
      v-model="show"
      scrollable
    >
      <v-card>
        <v-card-title>
          {{ editData ? 'Update summary' : 'New summary' }}
          {{ status ? '(summary is closed)': '' }}
          <v-spacer></v-spacer>
          <v-btn icon @click.prevent="show = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text style="max-height: 60vh">
          <v-container fluid>
            <v-row>
              <!-- Period -->
              <v-col cols="12" md="4" v-if="!editData">
                <v-select
                  :items="summaryPeriodItems"
                  item-text="text"
                  item-value="val"
                  v-model="summaryPeriod"
                  label="Period for summary"
                ></v-select>
              </v-col>
              <!-- /Period -->
              <!-- From date -->
              <v-col cols="12" :md="editData ? 6 : 4">
                <DatePicker
                  v-model="fromDate"
                  :disabled="status"
                />
              </v-col>
              <!-- /From date -->
              <!-- To date -->
              <v-col cols="12" :md="editData ? 6 : 4">
                <DatePicker
                  v-model="toDate"
                  :disabled="summaryPeriod > 6 || status"
                  :min="minDate"
                  :max="summaryPeriod == 6 ? maxDateWeekly : null"
                />
              </v-col>
              <!-- /To date -->
              <v-col cols="12">
                <!-- Description -->
                <DescriptionWithSpellCheck
                  label="Description"
                  v-model="summaryData.Summary"
                  :disabled="status"
                />
                <!-- /Description -->
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            v-if="!status"
            :disabled="!changed"
            small
            color="primary"
            @click.prevent="onSave"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import moment from 'moment'
import { formatLocalDate } from '@/utils/dateUtils'

export default {
  name: 'SummaryDialog',
  components: {
    DescriptionWithSpellCheck: () => import('@/components/reporting/DescriptionWithSpellCheck.vue'),
    DatePicker: () => import('@/components/global/DatePicker.vue')
  },
  props: {
    value: {
      required: true,
      type: Boolean,
      default: false
    },
    editData: {
      required: false,
      type: Object
    }
  },
  data () {
    return {
      summaryData: {
        Summary_ID: this.editData ? this.editData.Summary_ID : null,
        Project_ID: this.editData ? this.editData.Project_ID : this.$store.getters.getSelectedProject,
        From_Date: this.editData ? this.editData.From_Date : formatLocalDate(new Date()),
        To_Date: this.editData ? this.editData.To_Date : null,
        Summary: this.editData ? this.editData.Summary : null,
        Status: this.editData ? this.editData.Status : 'U'
      },
      summaryPeriodItems: [
        {
          text: 'Weekly',
          val: 6
        },
        {
          text: 'Monthly',
          val: 30
        },
        {
          text: 'Custom',
          val: 0
        }
      ],
      summaryPeriodSelected: this.editData ? 0 : 6
    }
  },
  computed: {
    changed () {
      if (this.editData) {
        for (const key in this.summaryData) {
          if (this.summaryData[key] !== this.editData[key]) return true
        }
        return false
      }
      return true
    },
    status () {
      return this.summaryData.Status === 'C'
    },
    show: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    fromDate: {
      get () {
        return this.summaryData.From_Date
      },
      set (val) {
        this.summaryData.From_Date = val
        if (!this.editData) {
          if (this.summaryPeriod === 30) {
            this.summaryData.To_Date = moment(val).endOf('month').format('YYYY-MM-DD')
          } else {
            this.summaryData.To_Date = moment(val).endOf('isoWeek').format('YYYY-MM-DD')
          }
        }
      }
    },
    toDate: {
      get () {
        return this.summaryData.To_Date
      },
      set (val) {
        this.summaryData.To_Date = val
      }
    },
    summaryPeriod: {
      get () {
        return this.summaryPeriodSelected
      },
      set (val) {
        this.summaryPeriodSelected = val
        if (!this.editData) {
          if (val === 30) {
            this.summaryData.To_Date = moment(this.summaryData.From_Date).endOf('month').format('YYYY-MM-DD')
          } else {
            this.summaryData.To_Date = moment(this.summaryData.From_Date).endOf('isoWeek').format('YYYY-MM-DD')
          }
        }
      }
    },
    minDate () {
      const startDate = new Date(this.summaryData.From_Date)
      const toDate = startDate.setDate(startDate.getDate())
      return formatLocalDate(toDate)
    },
    maxDateWeekly () {
      const startDate = new Date(this.summaryData.From_Date)
      const toDate = startDate.setDate(startDate.getDate() + 6)
      return formatLocalDate(toDate)
    }
  },
  mounted () {
    this.fromDate = this.summaryData.From_Date
  },
  methods: {
    checkFields () {
      for (const key in this.summaryData) {
        if (key === 'Summary_ID' && !this.editData) continue
        if (!this.summaryData[key]) return false
      }
      return true
    },
    onSave () {
      if (this.checkFields()) {
        this.$emit('onSave', {
          value: this.summaryData,
          update: !!this.editData || false
        })
        this.show = false
      } else {
        this.$store.dispatch('setError', { errorMsg: 'Please fill all fields' })
      }
    }
  }
}
</script>
<style lang="">

</style>
